import React, { Component } from 'react';
import { IMe, IFarm, INave, ISilo, IFeedPlan, IFeed, IIFeedPlan, IProduct, IPedido } from '../types';
import { createStyles, withStyles, Theme } from '@material-ui/core/styles';
import AppBar from './AppBar';
import OrderService from '../ApiClients/OrderService';
import Loader from './Loader';
import { addZeroesDecimals, getCurrentFeedPlanStage, addThousandSeparator, createArrayPedido, allowViewSilo, isDynamicsFarm } from '../helpers'
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import './ElementContainer.css';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Paper from '@material-ui/core/Paper';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import CreateModal from './CreateDialog';
import { cloneDeep, findIndex, sortBy } from 'lodash';
import { withParamsAndNavigate } from './Material/ReactRouter';

const styles = (theme: Theme) => createStyles({
    container: {
        padding: '10px',
        textAlign: 'center',
        overflowY:'auto'
    },
    image: {
        width: '100%',
        height: 'auto'
    },
    promotion: {
        //backgroundColor: '#f00',
        padding: '3px 15px',
        //color: '#fff',
        verticalAlign: 'middle',
    },
    root: {
    width: '100%',
    },
    paper: {
        width: '100%',
        marginTop: '30px',
        overflowX: 'auto',
    },
    heading: {
    fontSize: theme.typography.pxToRem(15),
    // fontWeight: theme.typography.fontWeightRegular,
    },
    item: {
        maxWidth:'200px',
        border: '2px solid #ccc',
        borderRadius: '15px',
        margin: '5px 10px',
        width: 'calc(100% - 20px)!important',
        boxShadow: '5px 5px 5px 0px rgba(0,0,0,0.50)',
        cursor: 'pointer',
        paddingTop: '10px',
        paddingBottom: '10px',
        position: 'relative',
    },
});

const getFeedColor=(etapa:IIFeedPlan, item:IIFeedPlan)=>{
    let downDesv = 100 - etapa.feed[0].lowerAllowedDeviation
    let qtyConsumidaPercentage = ((etapa.feed[0].qtyReal + etapa.feed[0].qtyReserved)/etapa.feed[0].qtyEstimated)*100;

    if(item.feedStage == (etapa.feedStage-1)){
        const prevFeed = item.feed[0];
        const prevQtyReg = prevFeed.qtyRegularization || 0;
        const prevConsumption = ((prevFeed.qtyReal + prevFeed.qtyReserved - prevQtyReg) / prevFeed.qtyEstimated) * 100;
        const prevUpperLimit = prevFeed.upperAllowedDeviation + 100;
        const prevRemaining = prevFeed.qtyEstimated - (prevFeed.qtyReal + prevFeed.qtyReserved - prevQtyReg);
        if(prevConsumption < prevUpperLimit){
            return('#b3e6b3')
        }
        return '#FFFFFF'
    }

    if(item.feedStage == (etapa.feedStage+1) && qtyConsumidaPercentage >= downDesv){
        return('#267326')
    }

    if(etapa.feedStage == item.feedStage){
        return('#39ac39')
    }
    return '#FFFFFF'
}

interface IFarmDetailProps {
    params?:any;
    navigate?:any;    
    classes: any;
    myInfo?:IMe;
}

interface IFarmDetailState {
    farm?: IFarm;
    loading: boolean;
    toggled: boolean;
    etapa?:IIFeedPlan;
    // Estados para solicitud de retirada
    retirementProducts: Array<IProduct>;
    currentProductIndex: number;
    openSiloDialog: boolean;
    retirementDate?: Date;
    retirementBatchId?: string;
    retirementFeedStage?: number;
    creationModalOpen: boolean;
    modalType: number;
    inputText: string;
    typeAction: number;
    loadingModal: boolean;
}

class FarmDetail extends Component<IFarmDetailProps, IFarmDetailState>  {
    constructor(props: IFarmDetailProps) {
        super(props);
        this.state = {
            loading: true,
            toggled:false,
            // Estados para solicitud de retirada
            retirementProducts: [],
            currentProductIndex: -1,
            openSiloDialog: false,
            retirementDate: undefined,
            retirementBatchId: undefined,
            retirementFeedStage: undefined,
            creationModalOpen: false,
            modalType: -1,
            inputText: '',
            typeAction: -1,
            loadingModal: false
        };
    }

    componentDidMount() {
        this.loadFarmDetail();
    }

    componentDidUpdate(prevProps: IFarmDetailProps) {
        if (this.props.params.farmRef !== prevProps.params.farmRef || this.props.params.business !== prevProps.params.business) {
            this.loadFarmDetail();
        }
    }

    loadFarmDetail = async () => {
        let farmRef = this.props.params.farmRef;
        let business = this.props.params.business;

        let response:IFarm = await OrderService.getFarm(business, farmRef);

        this.setState({farm:response, loading:false });
    }

    // ============= MÉTODOS PARA SOLICITUD DE RETIRADA =============

    handleRetirementRequest = async (feedPlanItem: IFeedPlan, stageItem: IIFeedPlan) => {
        if (!stageItem.feed || stageItem.feed.length === 0 || !this.state.farm) {
            return;
        }

        // Obtener la lista completa de productos
        const allProducts = await OrderService.getProducts(false, this.state.farm.id);
        
        if (!allProducts || allProducts.length === 0) {
            this.setState({
                inputText: '¡ATENCIÓN! No se pudieron cargar los productos.',
                modalType: 1,
                creationModalOpen: true,
                typeAction: -1
            });
            return;
        }

        // Convertir los feed items a productos del carrito
        const products: Array<IProduct> = stageItem.feed.map((feedItem: IFeed) => {
            const fullProduct = allProducts.find((p: IProduct) => 
                p.itemId === feedItem.itemId && p.business === this.state.farm!.business
            );

            const baseProduct = {
                ...(fullProduct || {}),
                itemId: feedItem.itemId,
                itemName: feedItem.itemName,
                unitId: feedItem.unitId,
                business: this.state.farm!.business,
                quantity: 0,
                batchId: feedItem.batchId,
                feedStage: stageItem.feedStage,
                numEtapa: stageItem.feedStage,
                silos: [],
                isInCart: true,
                type: fullProduct?.type || 1,
                typeDsc: fullProduct?.typeDsc || '',
                typeColor: fullProduct?.typeColor || '',
                medicated: fullProduct?.medicated || 0,
                subGroupArticleId: fullProduct?.subGroupArticleId || '',
                notRoundBox: fullProduct?.notRoundBox || 0,
                groupTypeSiloId: fullProduct?.groupTypeSiloId || [],
                price: fullProduct?.price || 0,
                maxQty: fullProduct?.maxQty || 0,
                continues: feedPlanItem.continues,
                remainingQty: feedItem.qtyReal || 0,
            } as IProduct;

            // Auto-seleccionar silo si solo hay uno compatible
            const compatibleSilos: Array<{nave: INave, silo: ISilo}> = [];
            this.state.farm!.building.forEach((nave: INave) => {
                nave.silo.forEach((silo: ISilo) => {
                    if (allowViewSilo(silo, baseProduct, 1)) {
                        compatibleSilos.push({ nave, silo });
                    }
                });
            });

            // Si solo hay 1 silo compatible, auto-seleccionarlo
            if (compatibleSilos.length === 1) {
                const { nave, silo } = compatibleSilos[0];
                baseProduct.silos = [{
                    ...silo,
                    buildingId: nave.buildingId,
                    order: 1,
                    quantity: 0,
                    full: false,
                    rest: false
                }];
            }

            return baseProduct;
        });

        // Iniciar el flujo: primero seleccionar silos para cada producto
        this.setState({
            retirementProducts: products,
            currentProductIndex: 0,
            retirementBatchId: feedPlanItem.batchId.toString(),
            retirementFeedStage: stageItem.feedStage,
            openSiloDialog: true
        });
    }

    handleSiloSelection = (nave: INave, silo: ISilo) => {
        const { retirementProducts, currentProductIndex } = this.state;
        let updatedProducts = cloneDeep(retirementProducts);
        let currentProduct = updatedProducts[currentProductIndex];

        // Verificar si el silo ya está seleccionado
        const siloIndex = findIndex(currentProduct.silos, (s: ISilo) => s.siloId === silo.siloId);

        if (siloIndex === -1) {
            // Calcular el orden del nuevo silo
            const nextOrder = currentProduct.silos.length + 1;
            
            // Añadir silo con campos requeridos por el SP (valores ficticios para retirada)
            currentProduct.silos.push({
                ...silo,
                buildingId: nave.buildingId,
                order: nextOrder,        // Orden secuencial
                quantity: 0,             // Cantidad 0 para retirada (la pondrá el transportista)
                full: false,             // No llenar completo (es retirada)
                rest: false              // No es resto
            });
        } else {
            // Quitar silo y reordenar los restantes
            currentProduct.silos.splice(siloIndex, 1);
            // Reordenar los silos restantes
            currentProduct.silos = currentProduct.silos.map((s: ISilo, idx: number) => ({
                ...s,
                order: idx + 1
            }));
        }

        updatedProducts[currentProductIndex] = currentProduct;
        this.setState({ retirementProducts: updatedProducts });
    }

    handleNextProduct = () => {
        const { currentProductIndex, retirementProducts, retirementBatchId, retirementFeedStage } = this.state;

        // Validar que se hayan seleccionado silos
        if (retirementProducts[currentProductIndex].silos.length === 0) {
            this.setState({
                inputText: '¡ATENCIÓN! Debe seleccionar al menos un silo para este producto.',
                modalType: 1,
                creationModalOpen: true,
                typeAction: -1
            });
            return;
        }

        // Validar cantidad estimada
        const currentProduct = retirementProducts[currentProductIndex];
        const qty = currentProduct.quantity || 0;
        const maxQty = this.getMaxEstimatedQty(currentProduct);

        if (qty <= 0 || (maxQty > 0 && qty > maxQty)) {
            return;
        }

        // Si hay más productos, pasar al siguiente
        if (currentProductIndex < retirementProducts.length - 1) {
            this.setState({
                currentProductIndex: currentProductIndex + 1
            });
        } else {
            // Si ya se procesaron todos los productos, usar fecha actual y mostrar confirmación
            const currentDate = new Date();
            
            this.setState({
                openSiloDialog: false,
                retirementDate: currentDate,
                inputText: `¿Quiere tramitar la solicitud de retirada de la etapa ${retirementFeedStage} del lote ${retirementBatchId}?`,
                modalType: 2,
                creationModalOpen: true,
                typeAction: 3
            });
        }
    }

    handlePreviousProduct = () => {
        const { currentProductIndex } = this.state;
        if (currentProductIndex > 0) {
            this.setState({
                currentProductIndex: currentProductIndex - 1
            });
        }
    }

    handleCloseSiloDialog = () => {
        this.setState({
            openSiloDialog: false,
            retirementProducts: [],
            currentProductIndex: -1
        });
    }

    handleEstimatedQtyChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
        const value = evt.target.value;
        if (value === '' || /^\d+$/.test(value)) {
            const { retirementProducts, currentProductIndex } = this.state;
            let updatedProducts = cloneDeep(retirementProducts);
            updatedProducts[currentProductIndex].quantity = value === '' ? 0 : parseInt(value, 10);
            this.setState({ retirementProducts: updatedProducts });
        }
    }

    getMaxEstimatedQty = (product: IProduct): number => {
        // For withdrawals, max qty is the consumed/served qty (qtyReal) for this article and stage
        const consumedQty = product.remainingQty || 0;
        return consumedQty;
    }

    handleCreateModal = async (typeAction: number) => {
        switch(typeAction) {
            case 3: // Tramitar solicitud de retirada
                await this.sendRetirementOrder();
                break;
            case 2: // Después de guardar correctamente
                this.afterSaveRetirement();
                break;
            default:
                break;
        }
    }

    sendRetirementOrder = async () => {
        const { retirementProducts, retirementDate, retirementBatchId, retirementFeedStage } = this.state;
        
        if (!this.state.farm || !retirementDate) {
            return;
        }

        this.setState({ loadingModal: true });

        try {
            // Crear el pedido de retirada
            const retirementOrder: IPedido = createArrayPedido(
                this.state.farm,
                retirementProducts,
                retirementDate,
                `Solicitud de retirada - Etapa ${retirementFeedStage} - Lote ${retirementBatchId}`,
                undefined,
                10,
                2 // moveType: 2 para devolución
            );

            // Llamar al endpoint
            const response = await OrderService.savePedido(retirementOrder, 1);
            
            let text = `¡ATENCIÓN! Se ha producido un error y no se ha podido guardar la solicitud de retirada.${(!response.valid && response.msg) ? ` Error: ${response.msg}` : ''}`;
            let modalType = 1;
            let typeAction = -1;

            if (response.valid) {
                if (response.data === 1) {
                    text = `Se ha generado la solicitud de retirada${response.msg ? ` "${response.msg}"` : ''} correctamente.`;
                    modalType = 3;
                    typeAction = 2;
                }
            }

            this.setState({
                inputText: text,
                modalType: modalType,
                creationModalOpen: true,
                typeAction: typeAction,
                loadingModal: false
            });
        } catch (error) {
            this.setState({
                inputText: '¡ATENCIÓN! Error al procesar la solicitud de retirada.',
                modalType: 1,
                creationModalOpen: true,
                typeAction: -1,
                loadingModal: false
            });
        }
    }

    afterSaveRetirement = () => {
        // Limpiar estados y cerrar modal
        this.setState({
            retirementProducts: [],
            currentProductIndex: -1,
            retirementDate: undefined,
            retirementBatchId: undefined,
            retirementFeedStage: undefined,
            creationModalOpen: false
        });
        
        // Recargar los datos de la granja
        this.loadFarmDetail();
    }

    onCloseCreationModal = () => {
        this.setState({ creationModalOpen: false });
    }

    loadBuildingData=(farm:IFarm)=>{
        let propagateItems = farm.building.map((nave:INave, index:number)=>{
            let silos = nave.silo.map((silo:ISilo, index:number)=>{
                return(
                    <ExpansionPanelDetails key={index}>
                        <div className={this.props.classes.item} style={{margin:'auto', display:'block'}}>
                            {'Silo: '}{silo.siloId}
                            <br/>
                            {`Capacidad: ${silo.capacity} ${silo.unitId}`}
                        </div>
                    </ExpansionPanelDetails>
                );
            });

            return (
                <ExpansionPanel key={index}>
                    <ExpansionPanelSummary key={index} expandIcon={<ExpandMoreIcon /> }>
                        <strong style={{ width: '100%', position: 'relative'}}>
                            {'Nave: '}{nave.buildingId}
                        </strong>
                    </ExpansionPanelSummary>
                    {silos}
                </ExpansionPanel>
            );
        });
        return propagateItems;
    }

    loadFeedPlan=(farm:IFarm)=>{
        let propagateFeedPlan = farm.feedPlan.map((item:IFeedPlan, index:number)=>{
            let feedPlan = 
                item.plan.map((item01:IIFeedPlan, index01:number)=>{
                    let idxFeedStage = getCurrentFeedPlanStage(item);
                    let etapa = undefined;

                    if(idxFeedStage > -1)
                        etapa = item.plan[getCurrentFeedPlanStage(item)];

                    let plan = <div>
                        <Paper className={this.props.classes.paper}>
                            <Table className={this.props.classes.table} aria-label="simple table">
                                <TableHead>
                                <TableRow>
                                <TableCell align="center">{`Producto`}</TableCell>
                                <TableCell align="center">{`Consumido`}</TableCell>
                                <TableCell align="center">{`Reservado`}</TableCell>
                                <TableCell align="center">{`Previsto`}</TableCell>
                                <TableCell align="center">{`Restante`}</TableCell>
                                {/*<TableCell align="center">{`Tipo`}</TableCell>*/}
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {item01.feed.map((result:IFeed, index:number) => (
                                <TableRow key={index}>
                                <TableCell align="center">
                                {result.itemName}
                                </TableCell>
                                <TableCell style={{whiteSpace:'nowrap'}} align="center">{`${addThousandSeparator(addZeroesDecimals((result.qtyReal),0),false)} ${result.unitId}`}</TableCell>
                                <TableCell style={{whiteSpace:'nowrap'}} align="center">{`${addThousandSeparator(addZeroesDecimals((result.qtyReserved),0),false)} ${result.unitId}`}</TableCell>
                                <TableCell style={{whiteSpace:'nowrap'}} align="center">{`${addThousandSeparator(addZeroesDecimals(result.qtyEstimated,0),false)} ${result.unitId}`}</TableCell>
                                <TableCell style={{whiteSpace:'nowrap'}} align="center">{`${addThousandSeparator(addZeroesDecimals(result.qtyEstimated - (result.qtyReal + result.qtyReserved),0),false)} ${result.unitId}`}</TableCell>
                                {/*<TableCell align="center">{result.IMPORTANCIA==0?'P':'S'}</TableCell>*/}
                                </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </Paper>
                    </div>

                    return(
                        <ExpansionPanel key={index}>
                            <ExpansionPanelSummary 
                                style={{backgroundColor:etapa?getFeedColor(etapa,item01):'#FFFFFF'}} 
                                key={index} 
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <div style={{ 
                                    width: '100%', 
                                    display: 'flex', 
                                    justifyContent: 'space-between', 
                                    alignItems: 'center',
                                    paddingRight: '10px'
                                }}>
                                    <strong style={{ position: 'relative'}}>
                                        {'ETAPA: '}{item01.feedStage}
                                    </strong>
                                    {/* Botón de Solicitud Retirada: solo visible para la etapa actual y granjas NO-Dynamics (SQL) */}
                                    {etapa && item01.feedStage === etapa.feedStage && item01.feed && item01.feed.length > 0 && !isDynamicsFarm(farm.business) && (
                                        <Button 
                                            size="small"
                                            variant="outlined"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                this.handleRetirementRequest(item, item01);
                                            }}
                                            style={{ 
                                                marginLeft: '10px',
                                                fontSize: '0.7rem',
                                                padding: '4px 8px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Solicitud Retirada
                                        </Button>
                                    )}
                                </div>
                            </ExpansionPanelSummary>
                            {plan}
                        </ExpansionPanel>
                    )
                })
            

            return (
                <ExpansionPanel key={index} style={{marginBottom:20, border: '1px solid #ddd'}}>
                    <ExpansionPanelSummary key={index} expandIcon={<ExpandMoreIcon /> }>
                        <div style={{whiteSpace:'wrap', textAlign: 'center', width: '100%'}}>
                            <div>
                                <strong style={{ width: '100%', position: 'relative'}}>
                                    {'LOTE'}
                                </strong>
                            </div>
                            <div>
                                <strong style={{ width: '100%', position: 'relative'}}>
                                    {item.batchId}
                                </strong>
                            </div> 
                        </div>
                    </ExpansionPanelSummary>
                    {feedPlan}
                </ExpansionPanel>
            )
        });
        return propagateFeedPlan;
    }
    
    render() {
        const { classes } = this.props;
        const { farm, retirementProducts, currentProductIndex, openSiloDialog } = this.state;

        return (
            <AppBar title={'Detalle Granja'} navigate={this.props.navigate} >
                {farm !== undefined ?
                    <div className={classes.container}>
                        <div style={{marginTop:30, marginBottom:30}}>
                        <Paper>
                            <Table className={classes.table} aria-label="simple table">
                                <TableBody>
                                <TableRow key={1}>
                                <TableCell align="left"><strong>{`ID Granja`}</strong></TableCell>
                                <TableCell align="center">{farm.id}</TableCell>
                                </TableRow>
                                <TableRow key={2}>
                                <TableCell align="left"><strong>{`Nombre`}</strong></TableCell>
                                <TableCell align="center">{farm.name}</TableCell>
                                </TableRow>
                                <TableRow key={3}>
                                <TableCell align="left"><strong>{`Lotes activos`}</strong></TableCell>
                                <TableCell align="center">
                                    <label>
                                        {farm.feedPlan.length == 0?
                                            `Sin lotes activos`
                                        :
                                            farm.feedPlan.map((feedplan:IFeedPlan, idx00:number)=>{
                                                return <p key={idx00}>{feedplan.batchId}</p>
                                            })
                                        }
                                    </label>
                                </TableCell> 

                                {/* <TableCell align="center">{`${farm.batchId==null?`Sin especificar`:farm.batchId}`}</TableCell> */}
                                </TableRow>
                                </TableBody>
                            </Table>
                        </Paper>
                        </div>

                        <div>
                            <div style={{marginBottom:20}}>
                                <strong>{`Información Nave/Silo`}</strong>
                            </div>
                            {this.loadBuildingData(farm)}
                        </div>

                        <div>
                            <div style={{marginBottom:20, marginTop:20}}>
                                    <strong>{`Plan alimentación`}</strong>
                            </div>
                            {this.loadFeedPlan(farm)}
                        </div>
                        
                    </div>
                    :
                    this.state.loading ?
                        <div style={{marginLeft:'50%',marginTop:200}}>
                            <Loader loading={this.state.loading}/>
                        </div>
                    :
                    <div className={classes.container}>
                        <h3>{'Información de granja no disponible'}</h3>
                    </div>
                }

                {/* Modal de selección de silos */}
                {openSiloDialog && retirementProducts.length > 0 && currentProductIndex >= 0 && (
                    <Dialog 
                        open={openSiloDialog} 
                        onClose={this.handleCloseSiloDialog}
                        maxWidth="md"
                        fullWidth
                    >
                        <DialogTitle>
                            {`Seleccionar silos a retirar el producto - Producto ${currentProductIndex + 1} de ${retirementProducts.length}`}
                        </DialogTitle>
                        <DialogContent>
                            <div style={{marginBottom: 20}}>
                                <label>Producto: </label>
                                <strong>{retirementProducts[currentProductIndex].itemName}</strong>
                            </div>

                            {(() => {
                                const product = retirementProducts[currentProductIndex];
                                const qty = product.quantity || 0;
                                const maxQty = this.getMaxEstimatedQty(product);
                                const hasError = qty > 0 && maxQty > 0 && qty > maxQty;
                                return (
                                    <div style={{marginBottom: 20}}>
                                        <TextField
                                            label="Cantidad estimada"
                                            variant="outlined"
                                            size="small"
                                            value={qty > 0 ? qty : ''}
                                            onChange={this.handleEstimatedQtyChange}
                                            inputProps={{ inputMode: 'numeric' }}
                                            error={hasError}
                                            helperText={hasError
                                                ? `La cantidad supera el máximo permitido (${maxQty} ${product.unitId})`
                                                : `Máximo: ${maxQty} ${product.unitId}`}
                                            fullWidth
                                        />
                                    </div>
                                );
                            })()}

                            <FormControl component="fieldset">
                                <FormLabel component="legend" style={{marginBottom: 10}}>Silos disponibles:</FormLabel>
                                <FormGroup>
                                    {farm?.building.map((nave: INave) => 
                                        nave.silo.map((silo: ISilo) => {
                                            const currentProduct = retirementProducts[currentProductIndex];
                                            const isSelected = findIndex(currentProduct.silos, (s: ISilo) => s.siloId === silo.siloId) !== -1;
                                            const isCompatible = allowViewSilo(silo, currentProduct, 1);
                                            
                                            if (!isCompatible) return null;

                                            return (
                                                <FormControlLabel
                                                    key={`${nave.buildingId}-${silo.siloId}`}
                                                    control={
                                                        <Checkbox
                                                            checked={isSelected}
                                                            onChange={() => this.handleSiloSelection(nave, silo)}
                                                            color="primary"
                                                        />
                                                    }
                                                    label={`Nave ${nave.buildingId} - Silo ${silo.siloId} (${silo.capacity} ${silo.unitId})`}
                                                />
                                            );
                                        })
                                    )}
                                </FormGroup>
                            </FormControl>

                            {retirementProducts[currentProductIndex].silos.length > 0 && (
                                <div style={{marginTop: 20}}>
                                    <FormLabel component="legend">Silos seleccionados:</FormLabel>
                                    <Paper style={{padding: 10, marginTop: 10}}>
                                        {sortBy(retirementProducts[currentProductIndex].silos, ['siloId']).map((silo: ISilo) => (
                                            <div key={silo.siloId} style={{padding: 5}}>
                                                Silo {silo.siloId}
                                            </div>
                                        ))}
                                    </Paper>
                                </div>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleCloseSiloDialog} color="default">
                                Cancelar
                            </Button>
                            {currentProductIndex > 0 && (
                                <Button onClick={this.handlePreviousProduct} color="default">
                                    Anterior
                                </Button>
                            )}
                            <Button onClick={this.handleNextProduct} color="primary" variant="contained">
                                {currentProductIndex < retirementProducts.length - 1 ? 'Siguiente' : 'Continuar'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}

                {/* Modal de confirmación y mensajes */}
                <CreateModal
                    onCloseCreationModal={this.onCloseCreationModal}
                    isOpen={this.state.creationModalOpen}
                    inputText={this.state.inputText}
                    typeModal={this.state.modalType}
                    action={this.handleCreateModal}
                    typeAction={this.state.typeAction}
                    loadingModal={this.state.loadingModal}
                    titleModal={''}
                    zIndex={1400}
                />
            </AppBar>
        );
    }
}
export default withParamsAndNavigate(withStyles(styles)(FarmDetail));